<template>
<body>
    <div style="background-color:#ffffff">

        <v-container>
            <Productos :title="title" :imgproducto="imgproducto" :txt1="txt1" :contenidos="contenidos" :txt2="txt2" :txt3="txt3" :ventas="ventas" :id="id" :txt4="txt4">
            </Productos >
            
       </v-container>
         

    </div>
    </body>
</template>


<script>
import Productos from "@/components/Productos.vue"

export default {
   
    components:{
       Productos
     },

    data(){
        return{
            id:"kit1",
            title:"Playera coloreable",
            imgproducto:"Playeracoloreable-incluye.jpg",
            txt1:"¡Tu hijo es un campeón!",
            
            /*contenidos:[
             {title:"Lotería"},
             {title:"Rompecabezas"},
             {title:"Memoramas"},
             {title:"Títeres"},
             {title:"Flashcards"},
             {title:"Acceso a la app Mundo Lalabum"}
            
           ],*/
           txt2:"Premia sus logros y desarrolla su creatividad con la playera coloreable Lalabum. ¡Pintan, se lava y vuelven  a pintar las veces que quieran!",
           txt3:"Incluye plumones y la suscripción a la app educativa Lalabum “Lalabum”. Tallas: 2, 4  y 6 años.",
           
           ventas:[
             {comercio:"Mercado Libre",url:"https://cutt.ly/ThrsKed"},
             {comercio:"Paypal",url:"https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=B6G3QLPQ65B4L"},
             /*{comercio:"Gonvil",url:"https://cutt.ly/4gYJovD"},
             {comercio:"Delti",url:"https://cutt.ly/4gYJovD"}*/
           ]
        }
    }
}
</script>

<style scoped>
.actividad.cuento{
    background-color:#4D93A8; 
    color: white;
    font-family: "Poppins";
    font-weight: 500;
    font-size: 1.5vw; 
    height: 60px;
  }

  @media (min-width: 1200px){
    .titlecuentos{
      font-size:1.2vw;
    }
  }

  .producto{
  color:red;
  
}
</style>


